import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import classnames from 'classnames';

import {
  LEAD_STATUS_ARCHIVED,
} from 'common/leadConstants';

import SrAgentLeadsListRow from 'client/components/SrAgentLeadsListRow';

@withRouter
class SrAgentLeadsSection extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    showPhoneNumber: PropTypes.bool.isRequired,
    items: PropTypes.array.isRequired,
    leadStatus: PropTypes.string,
    leadsRemovedFromStep: PropTypes.array.isRequired,
    leadsAddedToStep: PropTypes.array.isRequired,
    reloadTable: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
  };

  render() {
    const {
      title,
      showPhoneNumber,
      items,
      leadStatus,
      leadsRemovedFromStep,
      leadsAddedToStep,
      reloadTable,
      dispatch,
      history,
    } = this.props;

    return (
      <div className='dayContainer'>
        <div className={classnames('titleRow', { archived:  leadStatus === LEAD_STATUS_ARCHIVED })}>
          <span className='title'>{title.toLowerCase()}</span>
        </div>
        {items.map((lead) => (
          <SrAgentLeadsListRow
            key={lead.renter.id}
            lead={lead}
            reloadTable={reloadTable}
            isRemoved={leadsRemovedFromStep.includes(lead.renterUserId)}
            isAdded={leadsAddedToStep.includes(lead.renterUserId)}
            dispatch={dispatch}
            showPhoneNumber={showPhoneNumber}
            history={history}
          />
        ))}
      </div>
    );
  }
}

SrAgentLeadsSection.displayName = 'SrAgentLeadsSection';

export default SrAgentLeadsSection;
